import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import ListingBadge, { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base';
import { isREO } from './utils';
class BrokerCoopAvailableBadge extends ListingBadge {
    static title = 'Broker Co-op';
    static titleIcon = 'handshake-alt';
    static condensedTitle = 'Broker Commission Available';
    static renderPriority = BADGE_ORDER_PRIORITY.SIXTH;
    static contentPositive = true;
    static summary = 'Available';
    static shouldBeIncluded(listing) {
        return (listing.listing_configuration?.broker_commission_message && isREO(listing));
    }
    get content() {
        return (_jsxs(_Fragment, { children: [this.props.listing.listing_configuration.broker_commission_message, ' ', "commission is available."] }));
    }
}
class BrokerCoopUnavailableBadge extends ListingBadge {
    static title = 'Broker Co-op';
    static titleIcon = 'handshake-alt';
    static textIcon = 'times';
    static renderPriority = BADGE_ORDER_PRIORITY.SIXTH;
    static contentPositive = false;
    static summary = 'Not Offered';
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            !BrokerCoopAvailableBadge.shouldBeIncluded(listing));
    }
    get content() {
        return (_jsxs("span", { children: ["No Broker/Agent commission on this property.", ' ', _jsx("a", { href: '/lp/residential-agents', target: '_blank', children: "Learn more about Broker Co-op." })] }));
    }
}
export { BrokerCoopAvailableBadge, BrokerCoopUnavailableBadge };
//# sourceMappingURL=brokerCoop.js.map